import { gql, useMutation, useQuery } from "@apollo/client"
import { IGetMyHealthCoachFormsList, IGetMyHealthCoachFormsListInput, IGetMyHealthCoachFormsListOutput, IHealthCoachFMyHealthCoachFormsListOutputFrm, IHealthCoachFMyHealthCoachFormsListOutputTarget } from "../../../graphql/types/queries/forms"
import { GET_FORM_CONTENT, GET_MY_FORMS_LIST } from "../../../graphql/queries"
import { Button, Flex, Heading, Text } from "rebass/styled-components"
import { useState } from "react"
import { IFormMeta } from "./Builder"
import { toast } from "react-toastify"
import PleaseWait from "../../../components/PleaseWait"
import TextInput, { Input, TextInputWithLabel } from '../../../components/TextInput';
import { Form, Formik } from 'formik';
import FormField from '../../../components/FormField';
import { IOkPayload } from "../../../graphql/types/mutations/generics"
import withSession from "../../../lib/withSession"
import { IProperties } from "./types"
import { IUser } from "../../../graphql/types/queries/user"
import { useNavigate } from "react-router-dom"
import CheckboxInput from "../../../components/CheckboxInput"

const UPSERT_FORM = gql`
  mutation upsertHealthCoachForm(
    $id: String
    $tree: String!
    $name: String!
    $description: String
    $version: String!
    $target: String!
    $isActive: Boolean
    $isDeleted: Boolean
    $isDeprecated: Boolean
    $basedOnTemplate: String!
    $isFavorite: Boolean
  ) {
    upsertHealthCoachForm(
      id: $id
      tree: $tree
      name: $name
      description: $description
      version: $version
      target: $target
      isActive: $isActive
      isDeleted: $isDeleted
      isDeprecated: $isDeprecated
      basedOnTemplate: $basedOnTemplate
      isFavorite:$isFavorite
    ) {
      ok
    }
  }
`;

interface IUpsertFormOutput {
  upsertHealthCoachForm: IOkPayload
}

interface IUpsertFormInput {
  id?: string
  tree: string
  name: string
  description?: string
  version: string
  target: string
  isActive?: boolean
  isDeleted?: boolean
  isDeprecated?: boolean
  basedOnTemplate: string
  isFavorite?: boolean
}
interface IProps {
  meta: IFormMeta,
  tree: IProperties[]
  session: IUser
}
const SaveModal: React.FC<IProps> = ({ meta, tree, session }) => {
  const navigate = useNavigate()
  const [preLoadData, setPreLoadData] = useState<null | {
    target: IHealthCoachFMyHealthCoachFormsListOutputTarget,
    mine: IHealthCoachFMyHealthCoachFormsListOutputFrm[]
  }>(null)
  const [isActive, setIsActive] = useState()

  const [upsertForm, { loading: upsetingForm }] = useMutation<IUpsertFormOutput, IUpsertFormInput>(UPSERT_FORM, {
    refetchQueries: !!meta.id ? [{ query: GET_MY_FORMS_LIST }, { query: GET_FORM_CONTENT, variables: { formId: meta.id } }] : [{ query: GET_MY_FORMS_LIST }],
    awaitRefetchQueries: true,
    onCompleted: (e) => {
      if (!!e.upsertHealthCoachForm.ok) {
        toast.success(`Form created successfully`, {
          autoClose: 5000
        });
        navigate('/form-listing');
      } else {
        toast.error(`An error occured`, {
          autoClose: 10000
        });
      }
    },
    onError: () => {
      toast.error(`An error occured`, {
        autoClose: 10000
      });
    }
  })
  const { data, loading, error, refetch } = useQuery<IGetMyHealthCoachFormsListOutput, IGetMyHealthCoachFormsListInput>(GET_MY_FORMS_LIST, {
    onCompleted: (e) => {
      const target = e.getMyHealthCoachFormsList.find(x => x.target.id === meta.target)
      if (!target) {
        toast.error('An error occured', {
          autoClose: 5000
        })
        return
      }
      const mine = target.mine
      setPreLoadData({
        target: target.target,
        mine
      })
    }
  })

  if (!!loading) {
    return (
      <Flex flexDirection={'column'}>
        <Heading mb={4} textAlign={'center'}>Save Form</Heading>
        <PleaseWait />
      </Flex>
    )
  }

  if (!!error || !preLoadData) {
    return (
      <Flex flexDirection={'column'}>
        <Heading mb={4} textAlign={'center'}>Save Form</Heading>
        <Text textAlign={'center'}>An error occured</Text>
      </Flex>
    )
  }
  console.log({ preLoadData, id: meta.id })
  return (
    <Flex flexDirection={'column'}>
      <Heading textAlign={'center'}>Save Form</Heading>
      <Formik
        initialValues={{
          isActive: !!meta.id ? preLoadData.mine && preLoadData.mine.find(x => x.formId === meta.id)?.isActive : !!preLoadData.target.multipleAllowed || (preLoadData.mine && preLoadData.mine.filter(x => x.isActive === true).length < 1),
          isFavorite: !!meta.id ? preLoadData.mine && preLoadData.mine.find(x => x.formId === meta.id)?.isFavorite : false
        }}
        onSubmit={(values) => {
          console.log('SUB')
          // return
          const params = {
            id: meta.id || undefined,
            tree: JSON.stringify(tree),
            user: session.id,
            name: meta.name,
            description: meta.description,
            version: meta.version.toString(),
            target: meta.target,
            basedOnTemplate: meta.basedOnTemplate,
            isActive: values.isActive,
            isFavorite: values.isFavorite
          };

          upsertForm({
            variables: params,
          });
        }}

      >
        {({ touched, errors, isValid, values }) => {
          console.log({ values })
          return (
            <>
              <Form>

                <FormField flexDirection='row' mb={3} error={touched.isActive && errors.isActive}>
                  <TextInput type="checkbox" checked={values.isActive} id={`isActive`} name="isActive" />
                  <label htmlFor="isActive" style={{ marginLeft: '16px' }}>
                    is Active
                  </label>
                </FormField>
                {!!values.isActive && (
                  <FormField flexDirection='row' mb={4} error={touched.isFavorite && errors.isFavorite}>
                    <TextInput type="checkbox" checked={values.isFavorite} id={`isFavorite`} name="isFavorite" />
                    <label htmlFor="isFavorite" style={{ marginLeft: '16px' }}>
                      is Favorite
                    </label>
                  </FormField>
                )}
                {!!values.isActive && !preLoadData.target.multipleAllowed && preLoadData.mine && preLoadData.mine.filter(x => {
                  if (!!meta.id) return x.formId !== meta.id && x.isActive === true
                  return x.isActive === true
                }).length > 0 && (
                    <>
                      <Text>This target allows only 1 active form per user. Any other of your forms in this target will be deactivated and unfavorited:</Text>
                      {preLoadData.mine.filter(x => x.isActive === true).map(x => {
                        return (
                          <Text key={x.id}>- {x.name}</Text>
                        )
                      })}
                    </>
                  )}
                <Flex alignItems="center" flexDirection="column">
                  <Button disabled={!isValid} variant="primary" width={1 / 2} type="submit" id="btn_login">
                    Save
                  </Button>
                </Flex>
              </Form>

            </>
          );
        }}
      </Formik>
    </Flex>
  )
}

export default withSession(SaveModal)